/*
 * 分机管理导出
 *
 * *
 * */
import { nxExtenManageClient } from "@/api/nxExtenManageClient";
import { XExtenListReq } from "@/pbjs/xcommon/nxExtenManage_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";

export interface Options {
  Page: Page;
  UserName?: number;
  Supplier?: number;
  AssignStatus?: number;
  ExtNumber?: number;
  AddStartTime?: number;
  AddEndTime?: number;
  SearchStart?: number;
  SearchEnd?: number;
}
export function exportExcelReq(arg: Options) {
  let request: any = new XExtenListReq();
  request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
  request.setUsername(arg.UserName);
  request.setSupplier(arg.Supplier);
  request.setAssignstatus(arg.AssignStatus);
  request.setExtnumber(arg.ExtNumber);
  request.setAddstarttime(arg.AddStartTime);
  request.setAddendtime(arg.AddEndTime);
  request.setSearchstart(arg.SearchStart);
  request.setSearchend(arg.SearchEnd);
  return request;
}
export const exportExcelRequest = new InnerRequest(
  nxExtenManageClient,
  nxExtenManageClient.getExtenListExport
);